import React, { useState } from 'react'
import { Table } from 'components/Ui'
import { TextInput } from 'components/Form'

// CompanyFilters component
const CompanyFilters = ({ tableData, onChange }) => {
    const [filters, setFilters] = useState(() => {
        const existingFilters = tableData.filters || {}
        return {
            name: existingFilters.name || '',
            account_code: existingFilters.account_code || '',
            display_name: existingFilters.display_name || '',
        }
    })

    const handleFilterChange = (key, value) => {
        const newFilters = { ...filters, [key]: value }
        setFilters(newFilters)

        const newTableData = { ...tableData, filters: newFilters, pageIndex: 1 }
        onChange(newTableData)
    }

    const handleClearFilters = () => {
        const clearedFilters = {
            name: '',
            account_code: '',
            display_name: '',
        }
        setFilters(clearedFilters)
        const newTableData = { ...tableData, filters: clearedFilters, pageIndex: 1 }
        onChange(newTableData)
    }

    return (
        <div className="mb-6 p-6 bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700">
            {/* Filter Header */}
            <div className="flex items-center justify-between mb-4">
                <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Filter Companies</h3>
                <button
                    onClick={handleClearFilters}
                    className="px-4 py-2 text-sm font-medium text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 rounded-md transition-colors duration-200"
                >
                    Clear All
                </button>
            </div>

            {/* Company Information Filters Section */}
            <div>
                <h4 className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-3">Company Information</h4>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                    <div>
                        <label className="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">Company Name</label>
                        <TextInput
                            id="name"
                            name="name"
                            placeholder="Enter company name..."
                            value={filters.name || ''}
                            onChange={e => handleFilterChange('name', e.target.value)}
                            className="w-full"
                        />
                    </div>

                    <div>
                        <label className="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">Display Name</label>
                        <TextInput
                            id="display_name"
                            name="display_name"
                            placeholder="Enter display name..."
                            value={filters.display_name || ''}
                            onChange={e => handleFilterChange('display_name', e.target.value)}
                            className="w-full"
                        />
                    </div>

                    <div>
                        <label className="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">Account Code</label>
                        <TextInput
                            id="account_code"
                            name="account_code"
                            placeholder="Enter account code..."
                            value={filters.account_code || ''}
                            onChange={e => handleFilterChange('account_code', e.target.value)}
                            className="w-full"
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

// CompaniesTab component
const CompaniesTab = ({ companyData, companyTableData, columns, loading, company, dispatch, setCompanyTableData }) => {
    return (
        <>
            <CompanyFilters tableData={companyTableData} onChange={e => dispatch(setCompanyTableData(e))} />
            <Table
                key={`companies-${company}-${companyData?.length}`}
                loading={loading}
                filter={false}
                datas={companyData}
                columns={columns}
                pagingData={companyTableData}
                onChange={e => dispatch(setCompanyTableData(e))}
            />
        </>
    )
}

export default CompaniesTab
